"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeArray = void 0;
var tslib_1 = require("tslib");
exports.IkeArray = {
    /**
     *  Shallow clone a array
     *
     * @returns New array of elements
     **/
    clone: function (ary) {
        if (ary == null) {
            return [];
        }
        return ary.slice();
    },
    /**
     * Produces a duplicate-free version of the array.
     *
     * @param arr Array to iterate over.
     * @param key Key used to identify duplicate objects.
     */
    uniqueBy: function (arr, key) {
        var e_1, _a;
        if (!Array.isArray(arr)) {
            return [];
        }
        var seen = {};
        var uniqueArr = [];
        try {
            for (var arr_1 = tslib_1.__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var item = arr_1_1.value;
                if (item == null) {
                    continue;
                }
                var seenKey = item[key];
                if (seenKey != null && !seen[seenKey]) {
                    seen[seenKey] = true;
                    uniqueArr.push(item);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return uniqueArr;
    },
    /** Recursively flattens an array. */
    flatten: function (data, output) {
        var e_2, _a;
        if (output === void 0) { output = []; }
        try {
            for (var data_1 = tslib_1.__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var ary = data_1_1.value;
                if (Array.isArray(ary)) {
                    exports.IkeArray.flatten(ary, output);
                }
                else {
                    output.push(ary);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return output;
    },
    /**
     * Convert an array of objects to a map with each unique value assigned to the provided key.
     * @param arr Objects to convert into a map
     * @param key Key inside the object to use for conversion
     */
    toMap: function (arr, key) {
        var e_3, _a;
        var output = {};
        try {
            for (var arr_2 = tslib_1.__values(arr), arr_2_1 = arr_2.next(); !arr_2_1.done; arr_2_1 = arr_2.next()) {
                var obj = arr_2_1.value;
                output[obj[key]] = obj;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (arr_2_1 && !arr_2_1.done && (_a = arr_2.return)) _a.call(arr_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return output;
    },
    /**
    * Convert an array of objects to a map with each array of values assigned to the provided key.
    * @param arr Objects to convert into a map
    * @param key Key inside the object to use for conversion
    */
    groupBy: function (arr, key) {
        var e_4, _a;
        var output = {};
        try {
            for (var arr_3 = tslib_1.__values(arr), arr_3_1 = arr_3.next(); !arr_3_1.done; arr_3_1 = arr_3.next()) {
                var obj = arr_3_1.value;
                var value = obj[key];
                if (output[value] == null) {
                    output[value] = [obj];
                }
                else {
                    output[value].push(obj);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (arr_3_1 && !arr_3_1.done && (_a = arr_3.return)) _a.call(arr_3);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return output;
    },
    /**
     * Get the values in one array which are not found in the second.
     * Both arrays are treated as sets.
     *
     * @param arr1 Original Array
     * @param arr2 Other Array
     * @returns Values of `arr1` not in `arr2`
     */
    difference: function (arr1, arr2) {
        var e_5, _a;
        var store = new Set(arr2);
        var result = [];
        try {
            for (var arr1_1 = tslib_1.__values(arr1), arr1_1_1 = arr1_1.next(); !arr1_1_1.done; arr1_1_1 = arr1_1.next()) {
                var value = arr1_1_1.value;
                if (!store.has(value)) {
                    result.push(value);
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (arr1_1_1 && !arr1_1_1.done && (_a = arr1_1.return)) _a.call(arr1_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return result;
    },
    // differenceObj<T>(arr1: T[], arr2: T[], key): T[];
    /**
     * Creates an array of elements split into groups the length of size. If array can't be split evenly, the final chunk will be the remaining elements.
     *
     * @param array The array to process.
     * @param size The length of each chunk.
     * @returns The new array of chunks.
     */
    chunk: function (array, size) {
        var chunks = [];
        if (array == null || array.length === 0) {
            return chunks;
        }
        var count = Math.ceil(array.length / size);
        for (var i = 0; i < count; i++) {
            var currentChunk = array.slice(i * size, (i + 1) * size);
            chunks.push(currentChunk);
        }
        return chunks;
    }
};
//# sourceMappingURL=array.js.map